import { useEffect } from "react";
import useDeviceSize from "hooks/useDeviceSize";
import { useExtendedRouter } from "hooks";
import {
  ChakraBox as Box,
  ChakraDrawer as Drawer,
  ChakraDrawerOverlay as DrawerOverlay,
  ChakraDrawerContent as DrawerContent,
  ChakraDrawerCloseButton as DrawerCloseButton,
} from "@airhelp/react-ui-components";
import { useMobileMenuStore } from "stores/MobileMenuStore";
import type { MobileSideMenuProps } from "./MobileSideMenu.d";

export const MobileSideMenu = ({ children }: MobileSideMenuProps) => {
  const { isOpen, close, content } = useMobileMenuStore();
  const { isDesktop } = useDeviceSize();
  const router = useExtendedRouter();

  useEffect(() => {
    if (isDesktop) close();
  }, [isDesktop, close]);

  useEffect(() => {
    router.events.on("beforeHistoryChange", close);

    return () => {
      router.events.off("beforeHistoryChange", close);
    };
  }, [router, close]);

  return (
    <>
      {children}
      <Drawer isOpen={isOpen} onClose={close}>
        <Box display={{ lg: "none" }}>
          <DrawerOverlay bg="rgba(69, 84, 115, 0.7)" />
          <DrawerContent>
            <DrawerCloseButton
              size="lg"
              color="primary.900"
              _hover={{ color: "primary.500", bg: "white" }}
              _active={{ color: "primary.700", bg: "white" }}
              rounded="full"
              mt={2}
              mr={1}
            />
            {content}
          </DrawerContent>
        </Box>
      </Drawer>
    </>
  );
};
